/**
 * ownerKey — composite identity for a SKU at a shared 3PL location.
 *
 * The bare `sku` string is NOT unique across orgs sharing a location — the
 * 3PL owner and each connected client can each stock the same SKU string
 * (e.g. `TEE-M-BK`). Any lookup/dedup/existence decision keyed on bare
 * `sku` collapses every org's row into one (last write wins) — that's the
 * bug this key exists to close. Callers resolving an org id from an empty
 * Owner cell should pass their own org id; there is no "no owner" case.
 */
export const ownerKey = (orgId: string, sku: string): string =>
  `${orgId}::${sku.trim().toUpperCase()}`;
